import React from "react";

import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";

type DeleteToolbarActionProps = {
  onDelete(): void;
  selectedIds: string[];
};
const DeleteToolbarAction = ({
  onDelete,
  selectedIds,
}: DeleteToolbarActionProps) => {
  function handleClickDelete(evt: React.MouseEvent) {
    evt.preventDefault();
    onDelete();
  }

  if (selectedIds.length) {
    return (
      <Grid>
        <Tooltip title="Delete">
          <span>
            <Button
              aria-label="delete"
              color="primary"
              size="small"
              startIcon={<DeleteIcon />}
              onClick={handleClickDelete}
            >
              Delete
            </Button>
          </span>
        </Tooltip>
      </Grid>
    );
  }

  return <></>;
};
export default DeleteToolbarAction;
